import domReady from '@wordpress/dom-ready';

function initCustomDropdown(container) {
  const label = container.querySelector('.js-custom-dropdown-label');
  const labelText = label && label.querySelector('.js-label-text');
  const select = label && label.querySelector('.js-select');
  const content = container.querySelector('.js-custom-dropdown-content');
  const contentInner = container.querySelector(
    '.js-custom-dropdown-content-inner'
  );

  if (!label || !labelText || !select || !content || !contentInner) return;

  const options = container.querySelectorAll('.js-dropdown-option');
  const submitOnChange = container.dataset.submitonchange === 'true';
  const redirectOnChange = container.dataset.redirectonchange === 'true';
  const form = submitOnChange ? container.closest('form') : null;

  let isOpen = false;
  let selected = null;

  function setLabel() {
    labelText.textContent = selected.dataset.label;
  }

  function open() {
    if (isOpen) return;
    isOpen = true;

    container.classList.add('is-open');
    label.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    content.style.height = `${contentInner.offsetHeight}px`;
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;

    container.classList.remove('is-open');
    label.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.height = '0';
  }

  function toggle() {
    if (window.matchMedia('(hover: none)').matches) return;

    if (isOpen) {
      close();
    } else {
      open();
    }
  }

  function selectOption(option) {
    if (option.classList.contains('is-selected')) return;

    options.forEach((opt) => {
      opt.classList.remove('is-selected');
      opt.removeAttribute('aria-selected');
    });
    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');

    select.querySelectorAll('option').forEach((opt) => {
      opt.selected = opt.value === option.dataset.value;
    });

    selected = option;
    setLabel();
    close();

    if (submitOnChange && form) {
      form.submit();
    }

    if (redirectOnChange) {
      window.location.href = selected.dataset.value;
    }
  }

  function onSelectChange() {
    const option = Array.from(options).find(
      (opt) => opt.dataset.value === select.value
    );
    if (!option) return;

    options.forEach((opt) => {
      opt.classList.remove('is-selected');
      opt.removeAttribute('aria-selected');
    });
    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');

    selected = option;
    setLabel();
  }

  function initSelected() {
    selected = Array.from(options).find((opt) =>
      opt.classList.contains('is-selected')
    );

    if (!selected) {
      const [firstOption] = options;
      selected = firstOption;
      selected.classList.add('is-selected');
      selected.setAttribute('aria-selected', 'true');

      const [firstSelectOption] = select.querySelectorAll('option');
      if (firstSelectOption) firstSelectOption.selected = true;
    }

    setLabel();
  }

  label.addEventListener('click', toggle);
  label.addEventListener('keydown', (event) => {
    if ('Enter' === event.key || ' ' === event.key) {
      event.preventDefault();
      toggle();
    }
  });

  options.forEach((option) => {
    option.addEventListener('click', () => selectOption(option));
    option.addEventListener('keydown', (event) => {
      if ('Enter' === event.key || ' ' === event.key) {
        event.preventDefault();
        selectOption(option);
      }
    });
  });

  select.addEventListener('change', onSelectChange);

  document.addEventListener('click', (event) => {
    if (!isOpen) return;
    if (container.contains(event.target)) return;
    close();
  });

  initSelected();
}

domReady(() => {
  document
    .querySelectorAll('[data-component="custom_dropdown"]')
    .forEach(initCustomDropdown);
});
